import "./YourJourney.module.css";
import Header from "@/reusable_sections/Header";
import CoreBelief from "./sections/CoreBelief";
import YourJourney from "./sections/YourJourney";
import Spacer from "./sections/Spacer";
import Footer from "@/reusable_sections/Footer";
export default function YourJourneyPage() {
  return <div>
      <Header />
      <CoreBelief />
      <YourJourney />
      <Footer />
    </div>;
}